import { useLoadingStore } from 'store/loadingStore';

export const LOADING_KEY = {
  PROFILES: 'profiles',
  ID_VERIFICATIONS: 'identity-verifications',
  BANK_VERIFICATIONS: 'bank-account-verifications',
  WITHDRAWAL_REQUEST: 'withdrawal-request',
} as const;

export type LoadingKey = (typeof LOADING_KEY)[keyof typeof LOADING_KEY];
/**
 * withLoading 함수는 loading store(전역 상태)를 활용하여 fetching process에서의 loading 상태를 변경해주는 고차함수
 */
export const withLoading = async <T>(key: LoadingKey, fetchFn: () => Promise<T>): Promise<T> => {
  const { setLoading } = useLoadingStore.getState();

  setLoading(key, true); // 로딩 상태 활성화
  try {
    return await fetchFn(); // 비동기 함수 실행
  } finally {
    setLoading(key, false); // 로딩 상태 비활성화
  }
};
